export default {
    SET_ERRORS(state, value) {
        state.errors = value
    },
    SET_SUCCESS_MESSAGE(state, value) {
        state.successMessage = value
    },
    SET_LOADING(state, value) {
        state.loading = value
    },
    SET_ACCESS_TOKEN(state, value) {
        state.accessToken = value
    },
    SET_USER(state, value) {
        state.user = value
    },
    SET_TICKET_STATUS(state, value) {
        state.ticketStatus = value
    },
    SET_TICKET_ESCALATED(state, value) {
        state.ticketEscalated = value
    },
    SET_AUTH(state, value) {
        const { roles, permissions } = value
        state.auth.permissions = permissions || []
        state.auth.roles = roles || []
    },
    SET_IMAGES(state, value) {
        state.images = value
    },
    SET_TOPICS(state, value) {
        state.topics = value
    },
    SET_REFERRER_REGISTRATION(state, value) {
        state.isReferrerRegistered = value
    },
    setNotifications(state,value) {
        state.notifications = value
    },
    SET_APPS(state, value) {
        state.apps = value
    },
    SET_SELECTED_APP(state, value) {
        state.appSelected = value
    },
    SET_SELECTED_APP_GUIDE(state,value){
        state.guide_application_id = value
    },
    SET_GUIDE_TOPIC(state,value){
        state.guideTopicId = value
    },
    SET_GUIDE_TEST_RESULT(state,value){
        state.guideTestResultId = value
    },
}